export const clientKey = process.env.REACT_APP_PG_TOSS_CLIENT_KEY
export const variantKey = process.env.REACT_APP_PG_TOSS_VARIANT_KEY
